module.exports = __webpack_public_path__ + "static/img/gmldyl@2x.da1e3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/gmldyl@2x.png
// module id = 4MOb
// module chunks = 1